<template>
    <set-azure-arm-credentials-dialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('creatingAzureArmAccount')"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <post-cloud-account-button
                :value="{ ...form, Type: 'Azure' }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'creatingAzureArmAccount'"
                @http2xx="close().then(() => $emit('http2xx', $event))"
            ></post-cloud-account-button>
        </template>
    </set-azure-arm-credentials-dialog>
</template>

<script>
import SetAzureArmCredentialsDialog from '@/components/Settings.CloudAccounts/Azure/SetAzureARMCredentialsDialog';
import PostCloudAccountButton from '@/components/Settings.CloudAccounts/PostCloudAccountButton';
export default {
    components: { SetAzureArmCredentialsDialog, PostCloudAccountButton },
    props: {
        value: Boolean,
    },
};
</script>